export default {
  transactionRefundDialog: {
    title: 'Process Refund',
    info: 'Refunds typically process within 5-10 business days, depending on the payment method and bank.',
    refundOnly: 'Process refund only',
    refundAndUnsubscribe: 'Process refund and cancel subscription',
    subscriptionRelated: 'Subscription related',
    subscriptionRelatedTips: 'This indicates that the transaction is from a subscription.',
    remainingAmountTips: 'Payment partially refunded（Remaining {amount} {currency}）',
  },
};
